<script>
  import { asteroid, Subscriber, collections } from "@/meteor";
  import { debounce } from "@/utils";
  export let form, selected;
  let search = "";
  let { customers } = collections;
  let customer = false;

  const sub = Subscriber();
  $sub;

  const debouncer = debounce(function() {
    const query = {
      $text: {
        $search: search,
        $caseSensitive: false,
        $diacriticSensitive: false
      }
    };
    sub.setQuery("customers", query);
  }, 300);

  function selectCustomer(event) {
    const id = event.srcElement.dataset.id;
    customer = JSON.parse(JSON.stringify($customers[id]));
    search = customer.name;
  }

  function newSearch() {
    customer = false;
  }

  function setCustomer(id) {
    id = id || customer._id
    asteroid.call("orders.setCustomer", form._id, id);
  }

  async function createCustomer() {    
    const id = await asteroid.call("customers.insert", { name: search });
    setCustomer(id)
  }

  $: debouncer() && search;
</script>

Find kunde:
<div class="relative inline-block">
  {#if !customer}
    <input type="text" class="input focus" bind:value={search} />
    <div class="inline-block absolute mt-6 inset-0">
      <div class="absolute left-0 right-0 top-0 bg-white shadow">
        <ul>
          {#each Object.values($customers) as customer}
            <li
              class="cursor-pointer px-2 py-2 hover:bg-gray-100"
              on:click={selectCustomer}
              data-id={customer._id}>
              {customer.name}
            </li>
          {/each}
        </ul>
      </div>
    </div>
    {#if search}
      <button class="underline" on:click={createCustomer}>Opret {search} som kunde</button>
    {/if}
  {:else}
    <span on:click={newSearch}>
      {customer.name}
      <button>x</button>
    </span>
    <button class="btn outline green sm" on:click={setCustomer}>Bekræft</button>
  {/if}
</div>
